import { render, staticRenderFns } from "./BetButton.vue?vue&type=template&id=eba3e0dc&scoped=true"
import script from "./BetButton.vue?vue&type=script&lang=js"
export * from "./BetButton.vue?vue&type=script&lang=js"
import style0 from "./BetButton.vue?vue&type=style&index=0&id=eba3e0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba3e0dc",
  null
  
)

export default component.exports